import React from 'react';
import MessagingCenter from '../../patient/MessagingCenter';

export default function MessagesTab() {
  return (
    <div className="p-6">
      <MessagingCenter userRole="admin" />
    </div>
  );
}
